import {Button, Form, Input, Tabs, Upload} from "antd";
import i18next from "i18next";
import Icon, {UploadOutlined} from '@ant-design/icons';
import {ReactComponent as circle} from '../../../../assets/images/esri//x-circle-32.svg'
import {ReactComponent as save} from '../../../../assets/images/esri//save-32.svg'
import {MapService} from "../../../../service/mapService";
import React, {useState} from "react";
import {CreateItem} from "../../../CRUD/CreateItem";
import {DeleteItem} from "../../../CRUD/DeleteItem";
import MapToolsInMapTable from "./tables/MapToolsInMapTable";
import {MapToolService} from "../../../../service/mapToolService";
import {MapLayerService} from "../../../../service/mapLayerService";
import MapLayersInMapTable from "./tables/MapLayersInMapTable";
import {EditItem} from "../../../CRUD/EditItem";
import MapToolsInMapModal from "./modals/MapToolsInMapModal";
import MapLayersInMapModal from "./modals/MapLayersInMapModal";
import MapConfigModal from "./modals/MapConfigModal";


const EditMapConfigComponent = ({editMapConfig, setEditMapConfig, callback}) => {

    const [deleteTools, setDeleteTools] = useState([])//tools to be deleted
    const [addTools, setAddTools] = useState([])//tools to be added

    const [toolsOrder, setToolsOrder] = useState(editMapConfig.map.mapMaptoolList)
    const [layersOrder, setLayersOrder] = useState(editMapConfig.map.mapMaplyrList)

    const [deleteLayers, setDeleteLayers] = useState([])//tools to be deleted
    const [addLayers, setAddLayers] = useState([])//tools to be added

    const [displayFile, setDisplayFile] = useState([])

    const [showToolsTable, setShowToolsTable] = useState(false)//display tools modal
    const [showLayersTable, setShowLayersTable] = useState(false)//display layers modal

    const [showMapConfigModal, setShowMapConfigModal] = useState(false)

    const onClose = (e) => {
        setEditMapConfig(null);
    };

    const onFinish = bean => {
        //console.log(bean)
        MapService.editMap(bean).then(() => {

            //add/delete tools to/from map
            let toolsTemp = toolsOrder
            //console.log("end tools", toolsOrder)
            for (let i = 0; i < addTools.length; i++) {
                addToolToMap(addTools[i].idMapConf, addTools[i].idMapToolOrLayer, addTools[i].order)
            }
            for (let i = 0; i < deleteTools.length; i++) {
                deleteToolFromMap(deleteTools[i].mapId, deleteTools[i].itemId)
            }

            //sort tools based on draggable
            for (let i = 0; i < toolsOrder.length; i++) {
                if (toolsOrder[i].idMapTool != undefined) {
                    editToolFromMap(editMapConfig.map.idMapConf, toolsOrder[i].idMapTool, i)
                }
            }

            //add/delete layers to/from map
            for (let i = 0; i < addLayers.length; i++) {
                addLayerToMap(addLayers[i].idMapConf, addLayers[i].idMapToolOrLayer, addLayers[i].order)
            }
            for (let i = 0; i < deleteLayers.length; i++) {
                deleteLayerFromMap(deleteLayers[i].mapId, deleteLayers[i].itemId)
            }

            //sort layers based on draggable
            for (let i = 0; i < layersOrder.length; i++) {
                if (layersOrder[i].idMapLayer != undefined) {
                    editLayerToMap(editMapConfig.map.idMapConf, layersOrder[i].idMapLayer, i)
                }
            }

            //console.log("map updated")
            setEditMapConfig(null)
            callback()
        }).catch(err => {
            //console.log(err.response)
        })
    }

    const addToolToMap = (mapId, toolId, order) => {
        let bean = mapId + "/" + toolId + "/" + order
        CreateItem(MapToolService.addToolToMap, bean, "mapTool")
    }

    const editToolFromMap = (mapId, toolId, order) => {
        let compositeId = mapId + "/" + toolId + "/" + order
        EditItem(MapToolService.editToolToMap, compositeId, "mapTool from map", "mapTool from map")
    }

    const deleteToolFromMap = (mapId, toolId) => {
        let compositeId = mapId + "/" + toolId
        DeleteItem(MapToolService.deleteToolFromMap, compositeId, "mapTool from map")
    }

    const addLayerToMap = (mapId, layerId, order) => {
        let bean = mapId + "/" + layerId + "/" + order
        CreateItem(MapLayerService.addLayerToMap, bean, "mapLayer")
    }

    const editLayerToMap = (mapId, layerId, order) => {
        let compositeId = mapId + "/" + layerId + "/" + order
        EditItem(MapLayerService.editLayerToMap, compositeId, "mapLayer from map", "mapLayer from map")
    }

    const deleteLayerFromMap = (mapId, mapLayer) => {
        let compositeId = mapId + "/" + mapLayer
        DeleteItem(MapLayerService.deleteLayerFromMap, compositeId, "mapLayer from map")
    }

    const normFile = (e) => {
        //console.log('Upload event:', e)
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    /*const items = [
        {
            key: '1',
            label: i18next.t('common.tools.edit.map_tools'),
            children: <MapToolsInMapTable editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                          addTools={addTools} setAddTools={setAddTools}
                                          deleteTools={deleteTools} setDeleteTools={setDeleteTools} tools={toolsOrder}
                                          setTools={setToolsOrder}/>,
        },
        {
            key: '2',
            label: i18next.t('common.tools.edit.map_layers'),
            children: <MapLayersInMapTable editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                           addLayers={addLayers} setAddLayers={setAddLayers}
                                           deleteLayers={deleteLayers} setDeleteLayers={setDeleteLayers}
                                           layers={layersOrder} setLayers={setLayersOrder}/>,
        }
    ];*/

    return (
        <Form onFinish={onFinish}
              layout="vertical">
            <h2>{i18next.t('common.tools.edit.edit_form')}</h2>
            <div id="edit-form">
                <Form.Item hidden={true}
                           label={i18next.t('common.tools.edit.map.name')}
                           name="idMapConf"
                           initialValue={editMapConfig.map.idMapConf}
                           rules={[
                               {
                                   required: true,
                                   message: i18next.t('common.tools.edit.validation-msgs.required'),
                               },
                           ]}>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={i18next.t('common.tools.edit.map.name')}
                    name="name"
                    initialValue={editMapConfig.map.name}
                    rules={[
                        {
                            required: true,
                            message: i18next.t('common.tools.edit.validation-msgs.required'),
                        },
                    ]}>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={i18next.t('common.tools.edit.map.description')}
                    name="description"
                    initialValue={editMapConfig.map.description}
                    rules={[
                        {
                            required: true,
                            message: i18next.t('common.tools.edit.validation-msgs.required'),
                        },
                    ]}>
                    <Input/>
                </Form.Item>

                <MapConfigModal showModal={showMapConfigModal} setShowModal={setShowMapConfigModal} editMapConfig={editMapConfig}/>

                <Button type="primary" ghost onClick={() => setShowMapConfigModal(!showMapConfigModal)} style={{float: 'left'}}>Edit Map Configuration</Button>
                <br/>
                <br/>
                <br/>
                <Form.Item
                    name="objectList"
                    label={i18next.t('common.tools.edit.map.thumbnail')}
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    extra={<img alt={editMapConfig.map.name}
                                src={editMapConfig.map.thumbnailB64str} style={{
                        width: "auto",
                        maxWidth: "150px",
                        height: "100px"
                    }}/>}
                >
                    <Upload name="objectList" listType="picture" onChange={(e) => {
                    }}
                            getValueFromEvent={normFile} customRequest={(info) => {
                        setDisplayFile([info.file])
                    }}>
                        <Button icon={<UploadOutlined/>}>{i18next.t('common.tools.edit.upload-img')}</Button>
                        {displayFile[0]?.name}
                    </Upload>
                </Form.Item>

            </div>

            <MapToolsInMapModal showModal={showToolsTable} setShowModal={setShowToolsTable}
                                editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                addTools={addTools} setAddTools={setAddTools}
                                deleteTools={deleteTools} setDeleteTools={setDeleteTools}
                                tools={toolsOrder} setTools={setToolsOrder}/>

            <MapLayersInMapModal showModal={showLayersTable} setShowModal={setShowLayersTable}
                                 editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                 addLayers={addLayers} setAddLayers={setAddLayers}
                                 deleteLayers={deleteLayers} setDeleteLayers={setDeleteLayers}
                                 layers={layersOrder} setLayers={setLayersOrder}/>

            <br/>
            <Button type="primary" ghost onClick={() => setShowToolsTable(!showToolsTable)}>Show Tools Table</Button>
            <Button type="primary" ghost onClick={() => setShowLayersTable(!showLayersTable)}>Show Layers Table</Button>
            <br/>

            {/*<div id="tabs">
                <Tabs defaultActiveKey="1" items={items}/>
            </div>*/}

            <br/>
            <br/>
            <Form.Item>
                <Button onClick={(e) => onClose()}>
                    <Icon component={circle}/>
                    {i18next.t('common.tools.edit.exit')}
                </Button>
                <Button type="primary" htmlType="submit">
                    <Icon component={save}/>
                    {i18next.t('common.tools.edit.save')}
                </Button>
            </Form.Item>
        </Form>
    )
}
export default EditMapConfigComponent;